import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { logoutAccount } from '../actions/logout';
import { openInviteModal } from '../actions/invite';

import { getAuthenticatedIsAdmin } from '../selectors/auth';

import Footer from '../components/Footer';

const FooterContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { token, isAuthenticated, isAdmin } = useSelector((state) => {
    const hasToken = !!state.auth.token;
    const hasProfile = !!state.auth.hasProfile;
    
    return {
      token: state.auth.token,
      isAuthenticated: hasToken && hasProfile,
      isAdmin: hasToken ? getAuthenticatedIsAdmin(state) : false,
    };
  }, shallowEqual);

  const handleLogout = useCallback(() => {
    if (token) {
      dispatch(logoutAccount(token));
    }
  }, [dispatch, token]);

  const onInviteClick = useCallback(() => {
    dispatch(openInviteModal());
  }, [dispatch]);

  return (
    <Footer
      location={location}
      isAuthenticated={isAuthenticated}
      isAdmin={isAdmin}
      handleLogout={handleLogout}
      onInviteClick={onInviteClick}
    />
  );
};

FooterContainer.propTypes = {};

export default FooterContainer;
